export default __webpack_public_path__ + "static/media/pending.d220114e.svg";